import React, { ReactNode, useState } from "react";
import { SocialIcon } from "../utils/social-icon";
import ReactTooltip from "react-tooltip";
import { ItemWithMetaData } from "../api/Items";

import { MatchingEntities } from "../profiles/ProfileRow";
import CheckBox from "../shared-components/CheckBox";
import { TrashOutlineIcon } from "../shared-components/icons";

import LeftBorderedContainer from "../shared-components/LeftBorderedContainer";

type AmendmentProfileRowProps = {
  item: ItemWithMetaData;
  tabColor?: string;
  className?: string;
  children?: ReactNode;
  isManualAdd?: boolean;
  isReadOnly?: boolean;
  handleChange?: (checked: boolean) => void;
  trashIconForRemove?: boolean;
};

export function AmendmentProfileRemoveRow({
  item,
  tabColor,
  className,
  isManualAdd,
  isReadOnly,
  handleChange,
  trashIconForRemove,
}: AmendmentProfileRowProps) {
  const [selectedEntity, setSelectedEntity] = useState<{
    entityField: string;
    entities: { score: string; entities: string }[];
  }>();
  const profileUrl = item.item.content.url || "";

  return (
    <>
      <div className="bg-white my-3">
        <LeftBorderedContainer
          color={tabColor}
          className={`${className} border-y-gray-300 border-r-gray-300`}
        >
          <div className="flex flex-1 items-center overflow-hidden">
            <div>
              <SocialIcon url={profileUrl} />
            </div>
            <div className="flex-1 truncate pl-2">
              <a
                href={profileUrl}
                target="_blank"
                rel="noreferrer"
                className="text-base font-normal leading-6 truncate"
              >
                {profileUrl}
              </a>
              {!isManualAdd && (
                <MatchingEntities item={item} setSelected={setSelectedEntity} />
              )}
            </div>
            {!isReadOnly && (
              <div className="flex px-5">
                {!trashIconForRemove && (
                  <CheckBox
                    onChange={(e) => {
                      handleChange?.(e.target.checked);
                    }}
                  />
                )}
                {trashIconForRemove && (
                  <span
                    onClick={() => {
                      handleChange?.(true);
                    }}
                  >
                    <TrashOutlineIcon />
                  </span>
                )}
              </div>
            )}
          </div>

          {selectedEntity?.entityField && (
            <ReactTooltip
              id={selectedEntity.entityField}
              place="top"
              type="light"
              effect="solid"
              backgroundColor="white"
            >
              <div>
                {selectedEntity.entities?.map((e, i) => (
                  <div key={i}>{`${e.score} of ${e.entities}`}</div>
                ))}
              </div>
            </ReactTooltip>
          )}
        </LeftBorderedContainer>
      </div>
    </>
  );
}
